var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExploreBundlesWebappBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 899,
    height: 366,
    viewBox: "0 0 899 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.583481,
    y: -0.378258,
    width: 284.577,
    height: 196.958,
    rx: 7.5231,
    transform: "matrix(0.220004 -0.975499 0.980334 0.197346 -205.821 427.797)",
    fill: "#0F2747",
    stroke: "#DF6438",
    strokeWidth: 0.972194
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.583481,
    y: -0.378258,
    width: 284.577,
    height: 196.958,
    rx: 7.5231,
    transform: "matrix(0.220004 -0.975499 0.980334 0.197346 655.72 410.141)",
    fill: "#0F2747",
    stroke: "#DF6438",
    strokeWidth: 0.972194
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.687092,
    y: 0.156986,
    width: 323.989,
    height: 182.886,
    rx: 4.70957,
    transform: "matrix(0.860165 -0.510016 0.553323 0.832967 -299.799 33.4626)",
    fill: "#0F2747",
    stroke: "#DF6438",
    strokeWidth: 0.972194
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.209497,
    y: 0.637279,
    width: 203.022,
    height: 112.427,
    rx: 5.88987,
    transform: "matrix(0.903082 0.429468 -0.472105 0.881542 75.3583 -117.995)",
    fill: "#0F2747",
    stroke: "#BB1C17",
    strokeWidth: 0.972194
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.306912,
    y: 0.602184,
    width: 297.38,
    height: 205.295,
    rx: 9.95082,
    transform: "matrix(0.324729 0.945807 -0.95611 0.293008 400.658 185.228)",
    fill: "#0F2747",
    stroke: "#DF6438",
    strokeWidth: 0.972194
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -0.673637,
    y: 0.202864,
    width: 394.686,
    height: 382.461,
    rx: 20.289,
    transform: "matrix(-0.89192 -0.452193 -0.493888 0.869525 808.41 -72.036)",
    fill: "#0F2747",
    stroke: "#EA983F",
    strokeWidth: 0.972194
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -0.207247,
    y: 0.638685,
    width: 170.455,
    height: 164.829,
    rx: 8.50652,
    transform: "matrix(-0.901034 0.433749 0.474684 0.880156 134.436 308.877)",
    fill: "#0F2747",
    stroke: "#EA983F",
    strokeWidth: 0.972194
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreBundlesWebappBg);
export default __webpack_public_path__ + "static/media/explore-bundles-webapp-bg.b2f52c0e3792daefdd26a5f924801da8.svg";
export { ForwardRef as ReactComponent };